import ChoiceListSection from './ChoiceListSection.jsx';

const MultiSelectSection = ({ section }) => (
  <ChoiceListSection
    section={section}
    control="checkbox"
    multiple
    maxVisible={4}
    sortSelectedFirst
  />
);

export default MultiSelectSection;
